import { FC, PropsWithChildren, useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { GreenButton } from 'shared/components'
import { useCopyToClipboard } from 'shared/hooks/use-copy-to-clipboard'

const website = 'https://elementums.web.app'

export const SupportedBrowsersGate: FC<PropsWithChildren> = ({ children }) => {
  const [isUnsupportedBrowser, setIsUnsupportedBrowser] = useState(false)
  const copy = useCopyToClipboard()

  const isInAppBrowser = () => {
    const userAgent = navigator.userAgent
    return /FBAN|FBAV|Instagram/.test(userAgent)
  }

  useEffect(() => {
    setIsUnsupportedBrowser(isInAppBrowser())
  }, [])

  if (!isUnsupportedBrowser) return <>{children}</>

  return (
    <div className="flex flex-col items-center justify-center flex-1 h-screen gap-5 p-5">
      <p className="text-xl text-center">Please open the website in a supported browser to log in.</p>
      <GreenButton
        onClick={() => {
          toast.success('Copied!')
          copy(website)
        }}
        text="Copy website URL"
      />
    </div>
  )
}
